export enum Command {
  Uppercase = 'uppercase',
  Close = 'close',
}

export interface Key {
  value: string;
  command?: Command;
  height?: string;
  width?: string;
  order?: number;
}
